module.exports = __webpack_public_path__ + "img/sas.8456bf39.png";